import React, { PureComponent } from 'react';
import { Breadcrumb, BreadcrumbItem, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';

// modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';

class DMCA extends PureComponent {
  render() {
    return (
      <Container fluid className={styles.DMCA}>
        <Container>
          <Row>
            <Breadcrumb>
              <LinkContainer exact to="/">
                <BreadcrumbItem>
                  <Link to="/">Home</Link>
                </BreadcrumbItem>
              </LinkContainer>
              <LinkContainer exact to="/about">
                <BreadcrumbItem active>DMCA</BreadcrumbItem>
              </LinkContainer>
            </Breadcrumb>
          </Row>
        </Container>
        <Container>
          <h6>
            DIGITAL MILLENNIUM COPYRIGHT ACT ("DMCA") POLICY AND USER GENERATED
            SUBMISSIONS
          </h6>
          <p>
            <strong>Background.</strong> Some of the services offered by the M.L.S. of
            Naples ("Naples MLS") on the Sites that it operates allow you and others to
            post, transmit, display, publish, distribute, or otherwise submit public user
            generated material (collectively "Submissions") to the Sites, including, but
            not limited to, information about real property for sale or rent, the products
            or services related to a real estate transaction, issues related to home
            ownership and the acquisition or sale of real estate, and membership and
            products and services of the Naples MLS parent, the Naples Area Board of
            REALTORS<sup>®</sup> and Association of Real Estate Professionals, Inc. d/b/a/
            the Naples Area Board of REALTORS
            <sup>®</sup> ("NABOR<sup>®</sup>").
          </p>

          <p>
            <strong>Inappropriate Submissions.</strong> You agree not to post any
            Submission to the Sites that: contains vulgar, profane, abusive, hateful, or
            sexually explicit language, epithets or slurs, text in poor taste,
            inflammatory attacks of a personal, sexual, racial or religious nature, or
            expressions of bigotry, racism, discrimination or hate; is defamatory,
            threatening, disparaging, inflammatory, false, misleading, deceptive,
            fraudulent, inaccurate, or unfair, contains gross exaggeration or
            unsubstantiated claims, violates the privacy rights or right of publicity of
            any third party, is unreasonably harmful or offensive to any individual or
            community, contains any actionable statement, or tends to mislead or reflect
            unfairly on any other person, business or entity; unfairly interferes with any
            third party's uninterrupted use and enjoyment of the Sites; advertises,
            disparages, promotes or offers to trade any goods or services in any manner
            that does not comport with the purpose or spirit of the Sites, is intended
            primarily to promote a cause or movement, whether political, religious or
            other; contains copyrighted content (copyrighted articles, illustrations,
            images, text, or other content) without the express permission of the owner of
            the copyrights in the content; constitutes, promotes or encourages illegal
            acts, the violation of any right of any individual or entity, the violation of
            any local, state, national or international law, rule, guideline or
            regulation, or otherwise creates liability; discloses any personal identifying
            information relating to or images of a minor without consent of a parent,
            guardian or educational supervisor; infringes any copyright, trademark,
            patent, trade secret, or other intellectual property right; contains viruses
            or other harmful, disruptive or destructive files; or is inappropriate for
            minors to View; links to any commercial or other website; and/or is not
            otherwise in compliance with the Terms of Use applicable to a NABOR
            <sup>®</sup> operated Site.
          </p>

          <p>
            <strong>Your Representations and Warranties</strong>. Each time you provide a
            Submission to the Sites, you represent and warrant that you have the right to
            provide such Submission, which means:
            <ol>
              <li>You are the author of the Submission, or</li>
              <li>The Submission is not protected by copyright law, or</li>
              <li>
                You have express permission from the copyright owner to use the Submission
                in connection with the Sites; and you have the right to grant NABOR
                <sup>®</sup> the license set forth below, and your use of the Site(s) and
                Submission(s) do not violate the NABOR<sup>®</sup>’s Terms of Use
                applicable to the Site(s) to which you post the Submission.
              </li>
            </ol>
          </p>
          <p>
            <strong>User License Grant to Naples MLS.</strong> You grant Naples MLS, its
            affiliates, and related entities a royalty-free, perpetual, irrevocable,
            non-exclusive right and license to use, copy, modify, display, store, publish,
            transmit, perform, distribute, reproduce any Submissions you provide to the
            Naples MLS or to NABOR
            <sup>®</sup> in any form, media, software or technology of any kind now
            existing or developed in the future. Without limiting the generality of the
            previous sentence, you authorize the Naples MLS to include the Submissions you
            provide in a searchable format that may be accessed by users of the Sites. You
            also grant the Naples MLS and its related entities the right to use any of
            your Personally Identifiable Information (as that term is defined in the
            applicable Naples MLS Privacy Policy), included with any Submission in
            connection with the use, reproduction or distribution of such Submission. You
            also grant to the Naples MLS the right to use the Submission and any facts,
            ideas, concepts, know-how or techniques contained in any Submission or
            communication you send to the Naples MLS or NABOR<sup>®</sup> for any purpose
            whatsoever, including but not limited to, developing, promoting and/or
            marketing products and services. You grant all rights described in this
            paragraph in consideration of your use of the Sites, without compensation of
            any sort to you. Neither the Naples MLS nor NABOR<sup>®</sup> claim ownership
            of any Submissions.
          </p>
          <p>
            <strong>Disclaimer of Responsibility for Material.</strong> Neither the Naples
            MLS nor NABOR<sup>®</sup> endorse any Submissions, nor do any Submission
            necessarily represent the views of the Naples MLS or NABOR<sup>®</sup> or
            their subsidiaries and affiliates, agents, members, officers or directors. You
            acknowledge and agree that the Naples MLS does not control all Submissions,
            and disclaims any responsibility for such Submissions. The Naples MLS and
            NABOR
            <sup>®</sup>
            specifically disclaim any duty, obligation, or responsibility, to review,
            screen, refuse to post, remove, or edit any Submissions. In addition, neither
            the Naples MLS nor NABOR<sup>®</sup> represent or warrant that any other
            content or information accessible via the Sites is accurate, complete,
            reliable, current or error-free. Neither the Naples MLS nor NABOR<sup>®</sup>{' '}
            assume any responsibility or liability for any errors or omissions in the
            content of the Sites or in any Submissions.
          </p>
          <p>
            <strong>Review & Removal of Material.</strong> The Naples MLS reserves the
            right (but disclaims any duty, obligation or responsibility) to review,
            screen, refuse to post, remove in their entirety, or edit (at any time and
            without prior notice) any Submissions. If you believe any Submission or other
            content appearing on a MLS of Naples Site infringes upon your rights, you may
            contact the M.L.S. of Naples, Inc. at cindy@nabor.com or the M.L.S. of Naples.
            Inc. , 1455 Pine Ridge Road, Naples, Florida 34109 to request removal of such
            content or Submission; however, the Naples MLS disclaims any duty, obligation
            or responsibility to comply with such request except as specifically outlined
            in this paragraph. The Naples MLS also reserves the right (but disclaims any
            duty, obligation, or responsibility) to refuse to post, remove in their
            entirety, or edit (at any time and without prior notice) any Submissions on
            the Sites for any reason or no reason whatsoever, in its absolute and sole
            discretion.
          </p>

          <p>
            <strong>Digital Millennium Copyright Act (DMCA) Procedure.</strong>
            <br />
            <span className={BS.textUnderline}>DMCA Complaints</span>. The Digital
            Millennium Copyright Act of 1998 (the "DMCA") provides recourse for copyright
            owners who believe that material appearing on the Internet infringes their
            rights under United States Copyright Law. If you believe in good faith that
            Submissions posted by users of the Naples MLS Sites infringe your copyright,
            you (or your agent) may send the Naples MLS a notice requesting that the
            Submission(s) be removed from the Site(s), or access to it be blocked. The
            notice must include the following information: (a) a physical or electronic
            signature of a person authorized to act on behalf of the owner of an exclusive
            right that is allegedly infringed; (b) identification of the copyrighted work
            claimed to have been infringed (or if multiple copyrighted works located on
            the Sites are covered by a single notification, a representative list of such
            works); (c) identification of the material that is claimed to be infringing or
            the subject of infringing activity, and information reasonably sufficient to
            allow NABOR<sup>®</sup> to locate the Submission(s) on the Sites; (d) the
            name, address, telephone number and email address (if available) of the
            complaining party; (e) a statement that the complaining party has a good faith
            belief that use of the Submission in the manner complained of is not
            authorized by the copyright owner, its agent or the law; and (f) a statement
            that the information in the notification is accurate and, under penalty of
            perjury, that the complaining party is authorized to act on behalf of the
            owner of an exclusive right that is allegedly infringed. DMCA Complaints must
            meet the then current statutory requirements imposed by the DMCA; see
            https://www.copyright.gov for details. DMCA Complaints concerning materials on
            the Naples MLS Sites should be sent to the M.L.S. of Naples, Inc. , 1455 Pine
            Ridge Road, Naples, Florida 34109 ATTN: DMCA Complaint, or send the required
            information by email to cindy@nabor.com with "DMCA Complaint" in the subject
            line. Please note that you may be liable for damages (including costs and
            attorneys’ fees) if you materially misrepresent that material on a Naples MLS
            Site is infringing the copyrights of others. If you are uncertain whether
            material on a Naples MLS Site is infringing, the Naples MLS and NABOR
            <sup>®</sup> recommend seeking advice of an attorney.
          </p>
          <p>
            <span className={BS.textUnderline}>DMCA Counter Notices</span>. If the Naples
            MLS removes or disables access to content in response to a DMCA Complaint, the
            Naples MLS will make reasonable attempts to contact the owner of the removed
            or disabled content, or the owner’s agent. If the Naples MLS removed your
            material pursuant to another person’s DMCA Complaint and you contend that such
            material does not infringe upon another’s copyright rights, you may provide
            the Naples MLS with a counter notification by written communication labeled
            "DMCA Counter Notification" by sending such information to the M.L.S. of
            Naples, Inc., 1455 Pine Ridge Road, Naples, Florida 34109, or by email to
            cindy@nabor.com. The DMCA Counter Notification should contain all of the
            necessary information required by the DMCA, which can be found at{' '}
            <a
              href="https://www.copyright.gov/title17/92chap5.html#512"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.copyright.gov/title17/92chap5.html#512.
            </a>
          </p>
        </Container>
      </Container>
    );
  }
}

export default DMCA;



// WEBPACK FOOTER //
// ./src/containers/DMCA/DMCA.js